module.exports = __webpack_public_path__ + "static/img/1953.dba6c6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1953.jpg
// module id = GGKo
// module chunks = 0